module.exports = __webpack_public_path__ + "img/2369ccd32aaa5b0f606623d71cf2ad82.png";